import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	boardSettingsLabel: {
		id: 'navigation-board-action-menu.board-settings-label',
		defaultMessage: 'Board settings',
		description:
			'Description for a link to board settings page from a dropdown item in board actions',
	},
	deleteBoardLabel: {
		id: 'navigation-board-action-menu.delete-board-label',
		defaultMessage: 'Delete board',
		description:
			'Description for a menu item to delete board from a dropdown item in board actions',
	},
	dropdownIconLabel: {
		id: 'navigation-board-action-menu.dropdown-icon-label',
		defaultMessage: 'Board actions',
		description: 'Label for board actions dropdown button',
	},
});
